<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title></title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<div class="cn">Table of Contents</div>
<div class="toc2"><span class="col" href="#/OEBPS/cover" title="Link target outside of Sample">Cover</span></div>
<div class="toc"><a class="col" href="#/OEBPS/alsoby">A Selection of Recent Titles by Judith Cutler</a></div>
<div class="toc"><a class="col" href="#/OEBPS/title">Title Page</a></div>
<div class="toc"><a class="col" href="#/OEBPS/copyright">Copyright</a></div>
<div class="toc"><a class="col" href="#/OEBPS/dedication">Dedication</a></div>
<div class="toc"><a class="col" href="#/OEBPS/ack">Acknowledgements</a></div>
<p>  </p>
<div class="toc"><a class="col" href="#/OEBPS/chapter001">Chapter One</a></div>
<div class="toc"><a class="col" href="#/OEBPS/chapter002">Chapter Two</a></div>
<div class="toc"><a class="col" href="#/OEBPS/chapter003">Chapter Three</a></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter004" title="Link target outside of Sample">Chapter Four</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter005" title="Link target outside of Sample">Chapter Five</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter006" title="Link target outside of Sample">Chapter Six</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter007" title="Link target outside of Sample">Chapter Seven</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter008" title="Link target outside of Sample">Chapter Eight</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter009" title="Link target outside of Sample">Chapter Nine</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter010" title="Link target outside of Sample">Chapter Ten</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter011" title="Link target outside of Sample">Chapter Eleven</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter012" title="Link target outside of Sample">Chapter Twelve</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter013" title="Link target outside of Sample">Chapter Thirteen</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter014" title="Link target outside of Sample">Chapter Fourteen</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter015" title="Link target outside of Sample">Chapter Fifteen</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter016" title="Link target outside of Sample">Chapter Sixteen</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter017" title="Link target outside of Sample">Chapter Seventeen</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter018" title="Link target outside of Sample">Chapter Eighteen</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter019" title="Link target outside of Sample">Chapter Nineteen</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter020" title="Link target outside of Sample">Chapter Twenty</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter021" title="Link target outside of Sample">Chapter Twenty-One</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter022" title="Link target outside of Sample">Chapter Twenty-Two</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter023" title="Link target outside of Sample">Chapter Twenty-Three</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter024" title="Link target outside of Sample">Chapter Twenty-Four</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter025" title="Link target outside of Sample">Chapter Twenty-Five</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter026" title="Link target outside of Sample">Chapter Twenty-Six</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter027" title="Link target outside of Sample">Chapter Twenty-Seven</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter028" title="Link target outside of Sample">Chapter Twenty-Eight</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter029" title="Link target outside of Sample">Chapter Twenty-Nine</span></div>
<div class="toc"><span class="col" href="#/OEBPS/chapter030" title="Link target outside of Sample">Chapter Thirty</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2de805e2